
import './Menu.css'
import React from 'react'

class Menu extends React.Component {
  componentDidMount() {
    //TODO do it react way
    const toggler = document.querySelector('.menu__toggler');
    const menu = document.querySelector('.menu');

    toggler.addEventListener('click', () => {
      toggler.classList.toggle('active');
      menu.classList.toggle('active');
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="menu">
          <p>Menu Item #1</p>
          <p>Menu Item #2</p>
          <p>Menu Item #3</p>
        </div>
          <div className="menu__toggler">
            <span></span>
          </div>
      </React.Fragment>
    )
  }
}


export default Menu